import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { colors } from '../../styles/colors'
import { ConsultationButton } from '../UI/ConsultationButton'
import { Cross } from '../UI/Cross'
import logo from '../../img/logo.png'

const Container = styled.div`
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 10;

    padding: 2rem 2rem 4rem 2rem;
    background: ${colors.dark_blue};

    display: flex;
    flex-direction: column;
    align-items: center;

    @media (min-width: 1199.98px) {
        padding: 2rem 4rem 6rem 4rem;
    }

    // INCLUDED CLASSES:

    .logo-and-cross {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }
    .logo {
        width: 100px;
        height: 100px;
        background: url(${logo}) no-repeat 50% 50% ;
        background-size: cover;
        mix-blend-mode: multiply;
    }
    .cross-button {
        top: 5rem;
        right: 5rem;
    }
    .navigation-link {
        color: ${colors.white} !important;
        font-family: 'Lato',sans-serif;
        font-weight: 300;

        margin-bottom: 5rem;
    }
`

export const MobileMenu = () => {

    const dispatch = useDispatch()

    function handleConsultationButtonClick () {
        dispatch({ type: 'CONSULTATION_FORM_OPENED' })
        dispatch({ type: 'MOBILE_MENU_CLOSED' })
    }
    function closeMobileMenu () {
        dispatch({ type: 'MOBILE_MENU_CLOSED'})
    }

    return (
        <Container className='mobile-menu'>
            <div className="logo-and-cross">
                <div className={'logo'} />
                <div onClick={ closeMobileMenu } ><Cross lighten /></div>
            </div>
            <NavigationLink link='/' text='Главная' />
            <NavigationLink link='/products' text='Продукция' />
            <NavigationLink link='/service' text='Сервисное обслуживание' />
            <NavigationLink link='/contacts' text='Контакты' />
            <div onClick={()=> handleConsultationButtonClick() }> <ConsultationButton /> </div>
        </Container>
    )
}

function NavigationLink ({ link, text }) {
    const dispatch = useDispatch()
    function closeMobileMenu () {
        dispatch({ type: 'MOBILE_MENU_CLOSED'})
    }
    return <Link className='navigation-link' to={link} onClick={ closeMobileMenu } > {text} </Link>
}
